import RefreshIcon from '@mui/icons-material/Refresh';
import { CircularProgress, ListItemIcon, ListItemText, MenuItem } from '@mui/material';
import { defineMessage, FormattedMessage } from 'react-intl';
import { useFragmentMediaRegeneration } from './media-detail/useFragmentMediaRegeneration';

const regenerateMediaMessage = defineMessage({
  id: 'fragments.view.regenerateMedia',
  defaultMessage: 'Regenerar media',
});

interface FragmentViewRegenerateMediaMenuItemProps {
  /** Called after the regenerate action is triggered (e.g. to close the overflow menu). */
  onAction: () => void;
}

/**
 * Overflow menu item that starts fragment media regeneration.
 */
export function FragmentViewRegenerateMediaMenuItem({
  onAction,
}: FragmentViewRegenerateMediaMenuItemProps) {
  const { regenerate, isPending } = useFragmentMediaRegeneration();

  function handleClick() {
    regenerate();
    onAction();
  }

  return (
    <MenuItem onClick={handleClick} disabled={isPending}>
      <ListItemIcon>
        {isPending ? (
          <CircularProgress size={18} color="inherit" />
        ) : (
          <RefreshIcon fontSize="small" />
        )}
      </ListItemIcon>
      <ListItemText>
        <FormattedMessage {...regenerateMediaMessage} />
      </ListItemText>
    </MenuItem>
  );
}
